import {Component, ElementRef, Input} from '@angular/core';
import {WebsiteSpotPage} from '../../website-spot';

@Component({
    selector: 'cp-header',
    templateUrl: 'cp-header.html',
    providers: []
})
export class CpHeader {

    @Input('hpage') hpage: WebsiteSpotPage;
    @Input('blocked')    blocked: any;
    @Input('h-title')    htitle: 'h1' | 'h2' | 'h3';
    @Input('b-icone')    bicone: string;
    @Input('marginb')    marginb: number = 30;
    @Input('steptag')    steptag: number = 0;

    constructor(public element: ElementRef) {

    }

    styleWrap() {

        let style = {};

        let padtop = this.hpage.platenode(this.blocked, 'Header', 'Molded', 'Padtop') + 'px';
        let padbot = this.hpage.platenode(this.blocked, 'Header', 'Molded', 'Padbot') + 'px';

        let molde = this.hpage.platenode(this.blocked, 'Header', 'Molded', 'Source');
        if (molde) style = {'background': 'url(' + molde + ') no-repeat scroll top center', 'padding-top': padtop, 'padding-bottom': padbot};

        return style;

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/website-spot/components/cp-header/cp-header.ts